import { QueryObserverResult, useQueries, useQuery, UseQueryOptions } from 'react-query';
import { API } from '@base/core';

export function useGetUsers() {
  return useQuery(['users'], async () => {
    const q = await API.users.createUserQuery();
    return q.getNextPage(1000);
  });
}
